import { AiFillMail } from "react-icons/ai";
import { FiMessageSquare } from "react-icons/fi";
import { MdDownload } from "react-icons/md";
import { MdUpdate } from "react-icons/md";
import { BiMessageAltEdit, BiMessageSquareEdit } from "react-icons/bi";
import { MdUpload } from "react-icons/md";
import { BsChat, BsFillChatTextFill } from "react-icons/bs";
import AddOrderModal from "./AddOrderModal";
import { DateObject } from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import { addCommas } from "@persian-tools/persian-tools";
import { useEffect, useState } from "react";
import { useContext } from "react";
import { sendRequestAPI2 } from "hooks/useAxios";
import ReactTooltip from "react-tooltip";
import Select from "react-select";
import toast from "react-hot-toast";
import WithAuthentication from "Authentication/AuthenticationContext.ts";

import "./orders.scss";

export function ProductsRepair({
  data2,
  updateSelectedItem,
  index,
  pageType,
  orderLists,
  setOrderLists,
  updater,
  setUpdater,
  typeLogin,
  userType,
}) {
  console.log("typelogin", typeLogin);
  useEffect(() => ReactTooltip.rebuild());
  const [inputValue, setInptValue] = useState({
    statusPreviewSelect: "",
  });
  console.log("inputVVV", inputValue);
  const [statusPreviewSelect, setStatusPreviewSelect] = useState([
    { value: "3", label: "آماده ارسال" },
    { value: "4", label: "ارسال شده" },
    { value: "5", label: " تحویل داده شده" },
    { value: "6", label: "مشکل در ارسال " },
    { value: "7", label: " لغو شده  " },
  ]);
  const auth = useContext(WithAuthentication);
  console.log(" data2.main_status", data2);
  // useEffect(() => {
  //   setInptValue({
  //     statusPreviewSelect: statusPreviewSelect.find(
  //       (value) => value.value == data2.main_status
  //     ),
  //   });
  // }, [data2]);

  const statusPreview = (status) => {
    switch (status) {
      case "0":
        return "پرداخت شده";
        break;
      case "1":
        return "درانتظار اتمام خرید گروهی";
        break;
      case "2":
        return "اتمام خرید گروهی";
        break;
      case "3":
        return "آماده ارسال ";

        break;
      case "4":
        return "ارسال شده  ";

        break;
      case "5":
        return "تحویل شده  ";

        break;
      case "6":
        return "مشکل در ارسال  ";

        break;
      case "7":
        return "  لغو شده   ";

        break;
      case "8":
        return "کنسل شده";
        break;
      case "9":
        return "کنسل شده";
        break;
      default:
        return "نامشخص";
        break;
    }
  };
  const typeOfOrdersPreview = (status) => {
    switch (status) {
      case 0:
        return " افلاین";
        break;
      case 1:
        return " انلاین";
        break;
      default:
        return "نامعلوم";
        break;
    }
  };
  // const selectStatuse = (status) => {
  //   switch (status) {
  //     case 0:
  //       return 0;
  //       break;
  //     case 1:
  //       return 1;
  //       break;
  //     case 2:
  //       return 2;
  //       break;
  //     case 3:
  //       return 3;
  //       break;
  //   }
  // };
  // const changeStatuse = () => {
  //   sendRequestAPI2("change_order_status", {
  //     order_id: data2.id,
  //     status: inputValue.statusPreviewSelect.value,
  //   });
  //   console.log(statusPreviewSelect);
  // };
  const changeStatuse = (order_id, status) => {
    sendRequestAPI2("change_order_status", {
      order_id: order_id,
      status: status,
    }).then(({ data }) => {
      console.log("st", data);
      if (data.status == 1) {
        setUpdater((prev) => !prev);
      }
    });
    console.log(statusPreviewSelect);
  };
  console.log("updater", updater);
  // timestamo
  const timestampToDate = (time) => {
    if (time != "") {
      const a = time * 1000;
      const date = new DateObject({ date: a, calendar: persian });
      return date.format();
    }
  };
  let specialProducts = [],
    moreProducts = [];
  if (pageType != "groupList") {
    for (let index = 0; index < data2.items.length; index++) {
      if (index < 4) {
        specialProducts.push(
          <ProductsItem
            index={index}
            img={data2.items[index].images[0].url}
            title={data2.items[index].title}
            price={data2.items[index].main_price}
            desc={data2.items[index].description}
          ></ProductsItem>
        );
      } else {
        moreProducts.push(
          <ProductsItem
            index={index}
            title={data2.items[index].title}
            img={data2.items[index].images[0].url}
            price={data2.items[index].main_price}
            desc={data2.items[index].description}
            isMore={true}
          ></ProductsItem>
        );
      }
    }
  }

  if (pageType == "user") {
    return (
      <div className="row order-item2 mx-4 mt-5 repair ">
        <div className="d-flex justify-content-flex-start mx-0 mt-3 flex-wrap ">
          <div style={{ marginRight: "40px", marginTop: "10px" }}>
            <span style={{ color: "#707070" }}>نام کسب وکار </span>
            <span style={{ marginRight: "5px", marginLeft: "5px" }}>:</span>
            <span
              style={{
                marginRight: "10px",
                color: "#555761",
              }}
            >
              {data2.business.length > 0 && data2.business[0]?.title
                ? data2.business[0].title
                : "---"}
            </span>
          </div>

          <div style={{ marginRight: "30px", marginTop: "10px" }}>
            <span style={{ color: "#707070" }}> تعداد</span>
            <span style={{ marginRight: "5px", marginLeft: "5px" }}>:</span>
            <span style={{ marginRight: "10px", color: "#fa0520" }}>
              {pageType != "groupList" ? (
                <span>{data2.items_count}</span>
              ) : (
                <span>{data2.itemcount}</span>
              )}{" "}
            </span>
          </div>
          <div style={{ marginRight: "30px", marginTop: "10px" }}>
            <span style={{ color: "#707070" }}> شماره سفارش</span>
            <span style={{ marginRight: "5px", marginLeft: "5px" }}>:</span>
            <span style={{ marginRight: "10px", color: "#fa0520" }}>
              {data2.order_code}
            </span>
          </div>
          <div style={{ marginRight: "30px", marginTop: "10px" }}>
            <span style={{ color: "#707070" }}> مبلغ </span>
            <span style={{ marginRight: "5px", marginLeft: "5px" }}>:</span>
            <span style={{ marginRight: "10px", color: "#fa0520" }}>
              {addCommas(data2.total_amount)}تومان
            </span>
          </div>
          <div style={{ marginRight: "30px", marginTop: "10px" }}>
            <span style={{ color: "#707070" }}> آدرس خریدار</span>
            <span style={{ marginRight: "5px", marginLeft: "5px" }}>:</span>
            <span style={{ marginRight: "10px", color: "#fa0520" }}>
              {data2.rescipient_address}
              {/* {pageType != "groupList" ? (
                <span>{`${
                  data2.user_muid.length > 0
                    ? data2.user_muid[0].address
                    : "---"
                } `}</span>
              ) : (
                <span>{`${
                  data2.user_info.length > 0
                    ? data2.user_info[0].address
                    : "---"
                } `}</span>
              )}{" "} */}
            </span>
          </div>
          <div style={{ marginRight: "40px", marginTop: "10px" }}>
            <span style={{ color: "#707070" }}>وضعیت </span>
            <span style={{ marginRight: "5px", marginLeft: "5px" }}>:</span>
            <span style={{ marginRight: "10px", color: "#fa0520" }}>
              {statusPreview(data2.main_status)}
            </span>
          </div>
        </div>
        <div className="d-flex justify-content-flex-start mx-0 mt-5 flex-wrap">
          {specialProducts}
        </div>

        <div className="d-flex  mt-3 p-4">
          <div
            style={{
              width: "65%",
              textAlign: "left",
              alignSelf: "center",
              display: "flex",
              justifyContent: "left",
            }}
          >
            {/* <span
              style={{
                color: "rgb(250, 5, 32)",
                fontSize: "16px",
              }}
            >
              {statusPreview(data2.orderStatus)}
            </span> */}
            <div className="accordion" id="accordionExample">
              <div>
                <h2 className="accordion-header" id="headingOne"></h2>
              </div>
            </div>
          </div>
        </div>
        <div
          id={`collapseOne-${index}`}
          className="accordion-collapse collapse "
        >
          {pageType != "groupList" ? (
            <div className="accordion-body d-flex flex-wrap ">
              {moreProducts}
              <div></div>
            </div>
          ) : (
            ""
          )}
        </div>
        <div
          className="d-flex justify-content-between  admin-button"
          style={{ height: "auto" }}
        >
          {/* message icon */}
          <div
            data-for="gm-tooltip"
            data-tip=" پیام ها "
            onClick={() => {
              updateSelectedItem(data2);
            }}
            className="buttons"
            style={{
              color: "#457B9D",
              textDecoration: "none",
              marginRight: "10px",
              marginLeft: "7px",
              fontSize: "25px",
            }}
            data-bs-toggle="modal"
            data-bs-target="#StatusReportModal"
          >
            {/* {data2.Statusreport}  */}
            {
              // data2.chat[0].type == "user"
              data2.chats[data2.chats.length - 1] &&
              data2.chats[data2.chats.length - 1].type == "0" ? (
                <span
                  style={{
                    position: "relative",
                    marginRight: "10px",
                    marginLeft: "7px",
                    fontSize: "25px",
                    title: "پیام",
                  }}
                >
                  <div className="position-relative">
                    {/* <BsChat></BsChat> */}
                    <BsFillChatTextFill />

                    <div className=" rounded-pill position-absolute blink-message"></div>
                  </div>
                </span>
              ) : (
                <BsFillChatTextFill />
              )
            }
            {/* {/* {MessageIcon()} */}
          </div>
          {/* accordion button */}
          <div
            data-bs-toggle="collapse"
            data-bs-target={`#collapseOne-${index}`}
            aria-expanded="true"
            aria-controls="collapseOne"
          >
            <div className="d-flex justify-content-center ">
              <a
                href="#"
                style={{
                  color: "#457B9D",
                  textDecoration: "none",
                  fontSize: "15px",
                }}
                className="mx-auto"
              >
                جزئیات بیشتر
              </a>
            </div>
          </div>
          {/* paid modal */}
          {/* <div className="d-flex justify-content-end align-items-center paid-button">
            {data2.total_amount - data2.total_discount - data2.paid_amount >
            0 ? (
              <span
                data-for="gm-tooltip"
                data-tip="  تکمیل وجه "
                style={
                  {
                    // marginLeft: "15px",
                  }
                }
              >
                <button
                  style={{
                    marginLeft: "10px",
                    backgroundColor: "#10451d",
                    color: "white",
                    border: "none",
                    borderRadius: "15px",
                    padding: "8px 20px ",
                    fontSize: "18px",
                  }}
                  data-bs-toggle="modal"
                  data-bs-target="#ComolatePriceModal"
                  onClick={() => {
                    updateSelectedItem(data2);
                  }}
                >
                  تکمیل وجه
                </button>
                <span
                  onClick={() => {
                    updateSelectedItem(data2);
                  }}
                  style={{
                    color: "#457B9D",
                    textDecoration: "none",
                    fontSize: "50px",
                  }}
                  data-bs-toggle="modal"
                  data-bs-target="#StatusReportModal"
                ></span>
              </span>
            ) : (
              <span></span>
            )}
          </div> */}
        </div>
      </div>
    );
    // } else if (pageType == "superadmin" || typeLogin == "superAdmin") {
  } else if (typeLogin == "superAdmin") {
    return (
      <div className="row order-item2 mx-4 mt-4 repair">
        <div className="d-flex justify-content-flex-start mx-0 mt-3 flex-wrap ">
          <div style={{ marginRight: "40px", marginTop: "10px" }}>
            <span style={{ color: "#707070" }}>نام کسب وکار </span>
            <span style={{ marginRight: "5px", marginLeft: "5px" }}>:</span>
            <span
              style={{
                marginRight: "10px",
                color: "#555761",
              }}
            >
              {data2.business.length > 0 && data2.business[0]?.title
                ? data2.business[0].title
                : "---"}
            </span>
          </div>
          <div style={{ marginRight: "40px", marginTop: "10px" }}>
            <span style={{ color: "#707070" }}> تحویل گیرنده سفارش </span>
            <span style={{ marginRight: "5px", marginLeft: "5px" }}>:</span>
            <span
              style={{
                marginRight: "10px",
                color: "#555761",
              }}
            >
              {`${
                data2.rescipient_fullname ? data2.rescipient_fullname : "---"
              } `}

              {/* {pageType != "groupList" ? (
                <span>{`${data2.user_muid.fname} ${data2.user_muid.lname}`}</span>
              ) : (
                <span>{`${data2.user_info.fname} ${data2.user_info.lname}`}</span>
              )} */}
            </span>
          </div>
          <div style={{ marginRight: "40px", marginTop: "10px" }}>
            <span style={{ color: "#707070" }}>وضعیت </span>
            <span style={{ marginRight: "5px", marginLeft: "5px" }}>:</span>
            <span
              style={{
                marginRight: "10px",
                color: "#fa0520",
              }}
            >
              {statusPreview(data2.main_status)}
            </span>
          </div>

          <div
            className="d-flex flex-wrap"
            style={{
              marginRight: "40px",
              marginTop: "10px",
              direction: "column",
            }}
          >
            {/* <span style={{ color: "#707070" }}>تغییر وضعیت </span>
            <span style={{ marginRight: "5px", marginLeft: "5px" }}>:</span>
            <span className="slectStatuse" style={{}}>
              {console.log(
                "inputvaluefilter",
                inputValue,
                statusPreviewSelect.filter((value) => {
                  if (inputValue.statusPreviewSelect) {
                    return (
                      parseInt(value.value) >=
                      parseInt(inputValue.statusPreviewSelect.value)
                    );
                  } else {
                    return true;
                  }
                })
              )}
              <Select
                className="input-modal"
                id="statusPreviewSelect"
                options={statusPreviewSelect.filter((value) => {
                 
                  return parseInt(value.value) >= parseInt(data2.main_status);
                  
                })}
                placeholder="انتخاب..."
                value={inputValue.statusPreviewSelect}
                onChange={(e) => {
                  console.log("e", e);
                  setInptValue((prev) => {
                    return { ...prev, statusPreviewSelect: e };
                  });
                  changeStatuse(data2.id, e.value);
                }}
              ></Select>{" "}
            </span> */}
            <span style={{ color: "#707070" }}>تغییر وضعیت </span>
            <span style={{ marginRight: "5px", marginLeft: "5px" }}>:</span>
            <span className="slectStatuse" style={{}}>
              <Select
                className="input-modal"
                id="statusPreviewSelect"
                options={statusPreviewSelect}
                placeholder="انتخاب..."
                value={statusPreviewSelect.find(
                  (val) => val.value == inputValue.statusPreviewSelect
                )}
                onChange={(e) => {
                  setInptValue((prev) => {
                    return { ...prev, statusPreviewSelect: e };
                  });
                  changeStatuse(data2.id, e.value);
                }}
              ></Select>{" "}
            </span>
          </div>

          <div style={{ marginRight: "30px", marginTop: "10px" }}>
            <span style={{ color: "#707070" }}> تعداد</span>
            <span style={{ marginRight: "5px", marginLeft: "5px" }}>:</span>
            <span style={{ marginRight: "10px", color: "#fa0520" }}>
              {pageType != "groupList" ? (
                <span>{data2.items_count}</span>
              ) : (
                <span>{data2.itemcount}</span>
              )}{" "}
            </span>
          </div>
          <div style={{ marginRight: "30px", marginTop: "10px" }}>
            <span style={{ color: "#707070" }}> شماره سفارش</span>
            <span style={{ marginRight: "5px", marginLeft: "5px" }}>:</span>
            <span style={{ marginRight: "10px", color: "#fa0520" }}>
              {data2.order_code}
            </span>
          </div>
          <div style={{ marginRight: "30px", marginTop: "10px" }}>
            <span style={{ color: "#707070" }}> مبلغ </span>
            <span style={{ marginRight: "5px", marginLeft: "5px" }}>:</span>
            <span style={{ marginRight: "10px", color: "#fa0520" }}>
              {addCommas(data2.total_amount)}تومان
            </span>
          </div>
          <div style={{ marginRight: "30px", marginTop: "10px" }}>
            <span style={{ color: "#707070" }}> آدرس خریدار</span>
            <span style={{ marginRight: "5px", marginLeft: "5px" }}>:</span>
            <span style={{ marginRight: "10px", color: "#fa0520" }}>
              {data2.rescipient_address}
              {/* {pageType != "groupList" ? (
                <span>{`${
                  data2.user_muid.length > 0
                    ? data2.user_muid[0].address
                    : "---"
                } `}</span>
              ) : (
                <span>{`${
                  data2.user_info.length > 0
                    ? data2.user_info[0].address
                    : "---"
                } `}</span>
              )}{" "} */}
            </span>
          </div>
          {/* {pageType != "superadmin" ? (
            <div style={{ marginRight: "30px", marginTop: "10px" }}>
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="checkbox"
                  defaultValue
                  id="flexCheckDefault"
                />
                <div style={{ marginRight: "5px" }}>
                  <span style={{ color: "#707070" }}>
                    {" "}
                    بازگشت سود حاصل از خرید به کیف پول{" "}
                  </span>
                  <span style={{ marginRight: "5px", marginLeft: "5px" }}>
                    :
                  </span>
                  <span style={{ marginRight: "10px", color: "#fa0520" }}>
                    {addCommas("178000")}تومان
                  </span>
                </div>
              </div>
            </div>
          ) : (
            ""
          )} */}
        </div>
        <div className="d-flex justify-content-flex-start mx-0 mt-5 flex-wrap ">
          {specialProducts}
        </div>
        <div className="d-flex  mt-3 p-4">
          <div
            style={{
              width: "65%",
              textAlign: "left",
              alignSelf: "center",
              display: "flex",
              justifyContent: "left",
            }}
          >
            {/* <span
              style={{
                color: "rgb(250, 5, 32)",
                fontSize: "16px",
              }}
            >
              {statusPreview(data2.orderStatus)}
            </span> */}
            <div className="accordion" id="accordionExample">
              <div>
                <h2 className="accordion-header" id="headingOne"></h2>
              </div>
            </div>
          </div>
        </div>
        <div
          id={`collapseOne-${index}`}
          className="accordion-collapse collapse "
        >
          <div className="accordion-body d-flex flex-wrap ">
            {moreProducts}
            <div></div>
          </div>
          <div className="ms-5">
            ثبت کننده سفارش:
            {pageType != "groupList" ? (
              <span>{`${data2.user_muid.fname} ${data2.user_muid.lname}`}</span>
            ) : (
              <span>{`${data2.user_info.fname} ${data2.user_info.lname}`}</span>
            )}
          </div>
        </div>
        <div
          className="d-flex align-items-center justify-content-between admin-button"
          style={{ height: "auto" }}
        >
          {/* edit/message icon */}
          <div className="d-flex  justify-content-center buttons"></div>
          {/* accordion button */}
          <div
            data-bs-toggle="collapse"
            data-bs-target={`#collapseOne-${index}`}
            aria-expanded="true"
            aria-controls="collapseOne"
          >
            <div className="d-flex align-items-center justify-content-center me-2">
              <div>
                <a
                  href="#"
                  style={{
                    color: "#457B9D",
                    textDecoration: "none",
                    fontSize: "15px",
                  }}
                  className="mx-auto"
                >
                  جزئیات بیشتر
                </a>
              </div>
            </div>
          </div>
          {/* paid modal */}
          {/* <div className="d-flex align-items-center justify-content-end paid-button">
            {data2.total_amount - data2.total_discount - data2.paid_amount >
            0 ? (
              <span
                data-for="gm-tooltip"
                data-tip=" افزودن تکمیل وجه "
                style={
                  {
                    // marginLeft: "15px",
                  }
                }
              >
                <button
                  style={{
                    marginLeft: "10px",
                    backgroundColor: "#10451d",
                    color: "white",
                    border: "none",
                    borderRadius: "15px",
                    padding: "8px 20px ",
                    fontSize: "18px",
                  }}
                  data-bs-toggle="modal"
                  data-bs-target="#ComolatePriceModal"
                  onClick={() => {
                    updateSelectedItem(data2);
                  }}
                >
                  افزودن تکمیل وجه
                </button>
                <span
                  onClick={() => {
                    updateSelectedItem(data2);
                  }}
                  style={{
                    color: "#457B9D",
                    textDecoration: "none",
                    fontSize: "50px",
                  }}
                  data-bs-toggle="modal"
                  data-bs-target="#StatusReportModal"
                ></span>
              </span>
            ) : (
              <span></span>
            )}
          </div> */}
        </div>
      </div>
    );
    // } else if (pageType == "groupList" && auth.userInfo.userType == 0) {
  } else if (userType == 0) {
    return (
      <div className="row order-item2 mx-4 mt-4 repair ">
        <div className="d-flex justify-content-flex-start mx-0 mt-3 flex-wrap ">
          <div style={{ marginRight: "40px", marginTop: "10px" }}>
            <span style={{ color: "#707070" }}>تحویل گیرنده سفارش </span>
            <span style={{ marginRight: "5px", marginLeft: "5px" }}>:</span>
            <span
              style={{
                marginRight: "10px",
                color: "#555761",
              }}
            >
              {`${
                data2.rescipient_fullname != ""
                  ? data2.rescipient_fullname
                  : "---"
              } `}
              {/* {data2.NameUser} */}
              {/* {`${data2.rescipient_fname} ${data2.rescipient_lname}`} */}
              {/* {pageType != "groupList" ? (
                <span>{`${data2.user_muid.fname} ${data2.user_muid.lname}`}</span>
              ) : (
                <span>{`${data2.user_info.fname} ${data2.user_info.lname}`}</span>
              )} */}
            </span>
          </div>
          <div style={{ marginRight: "40px", marginTop: "10px" }}>
            <span style={{ color: "#707070" }}>وضعیت </span>
            <span style={{ marginRight: "5px", marginLeft: "5px" }}>:</span>
            <span style={{ marginRight: "10px", color: "#fa0520" }}>
              {statusPreview(data2.main_status)}
            </span>
          </div>
          <div
            className="d-flex flex-wrap"
            style={{
              marginRight: "40px",
              marginTop: "10px",
              direction: "column",
            }}
          >
            <span style={{ color: "#707070" }}>تغییر وضعیت</span>
            <span style={{ marginRight: "5px", marginLeft: "5px" }}>:</span>
            <span className="slectStatuse" style={{}}>
              <Select
                className="input-modal"
                id="statusPreviewSelect"
                options={statusPreviewSelect}
                placeholder="انتخاب..."
                value={statusPreviewSelect.find(
                  (val) => val.value == inputValue.statusPreviewSelect
                )}
                onChange={(e) => {
                  setInptValue((prev) => {
                    return { ...prev, statusPreviewSelect: e };
                  });
                  changeStatuse(data2.id, e.value);
                }}
              ></Select>{" "}
            </span>
          </div>
          <div style={{ marginRight: "30px", marginTop: "10px" }}>
            <span style={{ color: "#707070" }}> تعداد</span>
            <span style={{ marginRight: "5px", marginLeft: "5px" }}>:</span>
            <span style={{ marginRight: "10px", color: "#fa0520" }}>
              {pageType != "groupList" ? (
                <span>{data2.items_count}</span>
              ) : (
                <span>{data2.itemcount}</span>
              )}
            </span>
          </div>

          <div style={{ marginRight: "30px", marginTop: "10px" }}>
            <span style={{ color: "#707070" }}> مبلغ </span>
            <span style={{ marginRight: "5px", marginLeft: "5px" }}>:</span>
            <span style={{ marginRight: "10px", color: "#fa0520" }}>
              {addCommas(data2.total_amount)}تومان
            </span>
          </div>
          <div style={{ marginRight: "30px", marginTop: "10px" }}>
            <span style={{ color: "#707070" }}> آدرس خریدار</span>
            <span style={{ marginRight: "5px", marginLeft: "5px" }}>:</span>
            <span style={{ marginRight: "10px", color: "#fa0520" }}>
              {data2.rescipient_address}
              {/* {pageType != "groupList" ? (
                <span>{`${
                  data2.user_muid.length > 0
                    ? data2.user_muid[0].address
                    : "---"
                } `}</span>
              ) : (
                <span>{`${
                  data2.user_info.length > 0
                    ? data2.user_info[0].address
                    : "---"
                } `}</span>
              )}{" "} */}
            </span>
          </div>
          <div style={{ marginRight: "30px", marginTop: "10px" }}>
            <span style={{ color: "#707070" }}> مبلغ خرید </span>
            <span style={{ marginRight: "5px", marginLeft: "5px" }}>:</span>
            <span style={{ marginRight: "10px", color: "#fa0520" }}>
              <span>{`${data2.user_info?.address} `}</span>
            </span>
          </div>
          <div style={{ marginRight: "30px", marginTop: "10px" }}>
            <span style={{ color: "#707070" }}> میزان بازگشت به کیف پول </span>
            <span style={{ marginRight: "5px", marginLeft: "5px" }}>:</span>
            <span style={{ marginRight: "10px", color: "#fa0520" }}>
              <span>{`${data2.user_info?.address} `}</span>
            </span>
          </div>
          {/* <div style={{ marginRight: "30px", marginTop: "10px" }}>
            <div className="form-check">
              <input
                className="form-check-input"
                type="checkbox"
                defaultValue
                id="flexCheckDefault"
              />
              <div style={{ marginRight: "5px" }}>
                <span style={{ color: "#707070" }}>
                  {" "}
                  بازگشت سود حاصل از خرید به کیف پول{" "}
                </span>
                <span style={{ marginRight: "5px", marginLeft: "5px" }}>:</span>
                <span style={{ marginRight: "10px", color: "#fa0520" }}>
                  {addCommas("178000")}تومان
                </span>
              </div>
            </div>
          </div> */}
        </div>
        <div className="d-flex justify-content-flex-start mx-0 mt-5 flex-wrap ">
          {specialProducts}
        </div>
        <div className="d-flex  mt-3 p-4">
          <div
            style={{
              width: "65%",
              textAlign: "left",
              alignSelf: "center",
              display: "flex",
              justifyContent: "left",
            }}
          >
            {/* <span
              style={{
                color: "rgb(250, 5, 32)",
                fontSize: "16px",
              }}
            >
              {statusPreview(data2.orderStatus)}
            </span> */}
            <div className="accordion" id="accordionExample">
              <div>
                <h2 className="accordion-header" id="headingOne"></h2>
              </div>
            </div>
          </div>
        </div>
        <div
          id={`collapseOne-${index}`}
          className="accordion-collapse collapse "
        >
          <div className="accordion-body d-flex flex-wrap ">
            {moreProducts}
            <div></div>
          </div>
          <div className="ms-5">
            ثبت کننده سفارش:
            {pageType != "groupList" ? (
              <span>{`${data2.user_muid.fname} ${data2.user_muid.lname}`}</span>
            ) : (
              <span>{`${data2.user_info?.fname} ${data2.user_info?.lname}`}</span>
            )}
          </div>
        </div>
        <div
          className="d-flex  justify-content-center admin-button"
          style={{ height: "auto" }}
        >
          {/* edit/message icon */}
          <div className="d-flex align-items-center justify-content-start buttons"></div>
          {/* accordion button */}
          <div
            data-bs-toggle="collapse"
            data-bs-target={`#collapseOne-${index}`}
            aria-expanded="true"
            aria-controls="collapseOne"
          >
            <div className="d-flex align-items-center justify-content-center me-2">
              <div>
                <a
                  href="#"
                  style={{
                    color: "#457B9D",
                    textDecoration: "none",
                    fontSize: "15px",
                  }}
                  className="mx-auto"
                >
                  جزئیات بیشتر
                </a>
              </div>
            </div>
          </div>
          {/* paid modal */}
          {/* <div className="d-flex align-items-center justify-content-end paid-button">
            {data2.total_amount - data2.total_discount - data2.paid_amount >
            0 ? (
              <span
                data-for="gm-tooltip"
                data-tip=" افزودن تکمیل وجه "
                style={
                  {
                    // marginLeft: "15px",
                  }
                }
              >
                <button
                  style={{
                    marginLeft: "10px",
                    backgroundColor: "#10451d",
                    color: "white",
                    border: "none",
                    borderRadius: "15px",
                    padding: "8px 20px ",
                    fontSize: "18px",
                  }}
                  data-bs-toggle="modal"
                  data-bs-target="#ComolatePriceModal"
                  onClick={() => {
                    updateSelectedItem(data2);
                  }}
                >
                  افزودن تکمیل وجه
                </button>
                <span
                  onClick={() => {
                    updateSelectedItem(data2);
                  }}
                  style={{
                    color: "#457B9D",
                    textDecoration: "none",
                    fontSize: "50px",
                  }}
                  data-bs-toggle="modal"
                  data-bs-target="#StatusReportModal"
                ></span>
              </span>
            ) : (
              <span></span>
            )}
          </div> */}
        </div>
      </div>
    );
  } else if (userType == 2) {
    return (
      <div className="row order-item2 mx-4 mt-4 repair ">
        <div className="d-flex justify-content-flex-start mx-0 mt-3 flex-wrap ">
          <div style={{ marginRight: "40px", marginTop: "10px" }}>
            <span style={{ color: "#707070" }}>تحویل گیرنده سفارش </span>
            <span style={{ marginRight: "5px", marginLeft: "5px" }}>:</span>
            <span
              style={{
                marginRight: "10px",
                color: "#555761",
              }}
            >
              {`${
                data2.rescipient_fullname != ""
                  ? data2.rescipient_fullname
                  : "---"
              } `}
              {/* {data2.NameUser} */}
              {/* {`${data2.rescipient_fname} ${data2.rescipient_lname}`} */}
              {/* {pageType != "groupList" ? (
                <span>{`${data2.user_muid.fname} ${data2.user_muid.lname}`}</span>
              ) : (
                <span>{`${data2.user_info.fname} ${data2.user_info.lname}`}</span>
              )} */}
            </span>
          </div>
          <div style={{ marginRight: "40px", marginTop: "10px" }}>
            <span style={{ color: "#707070" }}>وضعیت </span>
            <span style={{ marginRight: "5px", marginLeft: "5px" }}>:</span>
            <span style={{ marginRight: "10px", color: "#fa0520" }}>
              {statusPreview(data2.main_status)}
            </span>
          </div>
          <div
            className="d-flex flex-wrap"
            style={{
              marginRight: "40px",
              marginTop: "10px",
              direction: "column",
            }}
          >
            <span style={{ color: "#707070" }}>تغییر وضعیت</span>
            <span style={{ marginRight: "5px", marginLeft: "5px" }}>:</span>
            <span className="slectStatuse" style={{}}>
              <Select
                className="input-modal"
                id="statusPreviewSelect"
                options={statusPreviewSelect.filter((value) => {
                  return parseInt(value.value) >= parseInt(data2.main_status);
                })}
                placeholder="انتخاب..."
                value={inputValue.statusPreviewSelect}
                onChange={(e) => {
                  console.log("e", e);
                  setInptValue((prev) => {
                    return { ...prev, statusPreviewSelect: e };
                  });
                  changeStatuse(data2.id, e.value);
                }}
              ></Select>{" "}
            </span>
          </div>
          <div style={{ marginRight: "30px", marginTop: "10px" }}>
            <span style={{ color: "#707070" }}> تعداد</span>
            <span style={{ marginRight: "5px", marginLeft: "5px" }}>:</span>
            <span style={{ marginRight: "10px", color: "#fa0520" }}>
              {pageType != "groupList" ? (
                <span>{data2.items_count}</span>
              ) : (
                <span>{data2.itemcount}</span>
              )}
            </span>
          </div>

          <div style={{ marginRight: "30px", marginTop: "10px" }}>
            <span style={{ color: "#707070" }}> مبلغ </span>
            <span style={{ marginRight: "5px", marginLeft: "5px" }}>:</span>
            <span style={{ marginRight: "10px", color: "#fa0520" }}>
              {addCommas(data2.total_amount)}تومان
            </span>
          </div>
          <div style={{ marginRight: "30px", marginTop: "10px" }}>
            <span style={{ color: "#707070" }}> آدرس خریدار</span>
            <span style={{ marginRight: "5px", marginLeft: "5px" }}>:</span>
            <span style={{ marginRight: "10px", color: "#fa0520" }}>
              {data2.rescipient_address}
              {/* {pageType != "groupList" ? (
                <span>{`${
                  data2.user_muid.length > 0
                    ? data2.user_muid[0].address
                    : "---"
                } `}</span>
              ) : (
                <span>{`${
                  data2.user_info.length > 0
                    ? data2.user_info[0].address
                    : "---"
                } `}</span>
              )}{" "} */}
            </span>
          </div>
          <div style={{ marginRight: "30px", marginTop: "10px" }}>
            <span style={{ color: "#707070" }}> مبلغ خرید </span>
            <span style={{ marginRight: "5px", marginLeft: "5px" }}>:</span>
            <span style={{ marginRight: "10px", color: "#fa0520" }}>
              <span>{`${data2.user_info?.address} `}</span>
            </span>
          </div>
          <div style={{ marginRight: "30px", marginTop: "10px" }}>
            <span style={{ color: "#707070" }}> میزان بازگشت به کیف پول </span>
            <span style={{ marginRight: "5px", marginLeft: "5px" }}>:</span>
            <span style={{ marginRight: "10px", color: "#fa0520" }}>
              <span>{`${data2.user_info?.address} `}</span>
            </span>
          </div>
          {/* <div style={{ marginRight: "30px", marginTop: "10px" }}>
            <div className="form-check">
              <input
                className="form-check-input"
                type="checkbox"
                defaultValue
                id="flexCheckDefault"
              />
              <div style={{ marginRight: "5px" }}>
                <span style={{ color: "#707070" }}>
                  {" "}
                  بازگشت سود حاصل از خرید به کیف پول{" "}
                </span>
                <span style={{ marginRight: "5px", marginLeft: "5px" }}>:</span>
                <span style={{ marginRight: "10px", color: "#fa0520" }}>
                  {addCommas("178000")}تومان
                </span>
              </div>
            </div>
          </div> */}
        </div>
        <div className="d-flex justify-content-flex-start mx-0 mt-5 flex-wrap ">
          {specialProducts}
        </div>
        <div className="d-flex  mt-3 p-4">
          <div
            style={{
              width: "65%",
              textAlign: "left",
              alignSelf: "center",
              display: "flex",
              justifyContent: "left",
            }}
          >
            {/* <span
              style={{
                color: "rgb(250, 5, 32)",
                fontSize: "16px",
              }}
            >
              {statusPreview(data2.orderStatus)}
            </span> */}
            <div className="accordion" id="accordionExample">
              <div>
                <h2 className="accordion-header" id="headingOne"></h2>
              </div>
            </div>
          </div>
        </div>
        <div
          id={`collapseOne-${index}`}
          className="accordion-collapse collapse "
        >
          <div className="accordion-body d-flex flex-wrap ">
            {moreProducts}
            <div></div>
          </div>
          <div className="ms-5">
            ثبت کننده سفارش:
            {pageType != "groupList" ? (
              <span>{`${data2.user_muid.fname} ${data2.user_muid.lname}`}</span>
            ) : (
              <span>{`${data2.user_info?.fname} ${data2.user_info?.lname}`}</span>
            )}
          </div>
        </div>
        <div
          className="d-flex  justify-content-center admin-button"
          style={{ height: "auto" }}
        >
          {/* edit/message icon */}
          <div className="d-flex align-items-center justify-content-start buttons"></div>
          {/* accordion button */}
          <div
            data-bs-toggle="collapse"
            data-bs-target={`#collapseOne-${index}`}
            aria-expanded="true"
            aria-controls="collapseOne"
          >
            <div className="d-flex align-items-center justify-content-center me-2">
              <div>
                <a
                  href="#"
                  style={{
                    color: "#457B9D",
                    textDecoration: "none",
                    fontSize: "15px",
                  }}
                  className="mx-auto"
                >
                  جزئیات بیشتر
                </a>
              </div>
            </div>
          </div>
          {/* paid modal */}
          {/* <div className="d-flex align-items-center justify-content-end paid-button">
            {data2.total_amount - data2.total_discount - data2.paid_amount >
            0 ? (
              <span
                data-for="gm-tooltip"
                data-tip=" افزودن تکمیل وجه "
                style={
                  {
                    // marginLeft: "15px",
                  }
                }
              >
                <button
                  style={{
                    marginLeft: "10px",
                    backgroundColor: "#10451d",
                    color: "white",
                    border: "none",
                    borderRadius: "15px",
                    padding: "8px 20px ",
                    fontSize: "18px",
                  }}
                  data-bs-toggle="modal"
                  data-bs-target="#ComolatePriceModal"
                  onClick={() => {
                    updateSelectedItem(data2);
                  }}
                >
                  افزودن تکمیل وجه
                </button>
                <span
                  onClick={() => {
                    updateSelectedItem(data2);
                  }}
                  style={{
                    color: "#457B9D",
                    textDecoration: "none",
                    fontSize: "50px",
                  }}
                  data-bs-toggle="modal"
                  data-bs-target="#StatusReportModal"
                ></span>
              </span>
            ) : (
              <span></span>
            )}
          </div> */}
        </div>
      </div>
    );
  } else if (typeLogin == "adminShop") {
    return (
      <div className="row order-item2 mx-4 mt-4 repair">
        <div className="d-flex justify-content-flex-start mx-0 mt-3 flex-wrap ">
          <div style={{ marginRight: "40px", marginTop: "10px" }}>
            <span style={{ color: "#707070" }}> تحویل گیرنده سفارش </span>
            <span style={{ marginRight: "5px", marginLeft: "5px" }}>:</span>
            <span
              style={{
                marginRight: "10px",
                color: "#555761",
              }}
            >
              {`${
                data2.rescipient_fullname ? data2.rescipient_fullname : "---"
              } `}

              {/* {pageType != "groupList" ? (
                <span>{`${data2.user_muid.fname} ${data2.user_muid.lname}`}</span>
              ) : (
                <span>{`${data2.user_info.fname} ${data2.user_info.lname}`}</span>
              )} */}
            </span>
          </div>
          <div style={{ marginRight: "40px", marginTop: "10px" }}>
            <span style={{ color: "#707070" }}>وضعیت </span>
            <span style={{ marginRight: "5px", marginLeft: "5px" }}>:</span>
            <span
              style={{
                marginRight: "10px",
                color: "#fa0520",
              }}
            >
              {statusPreview(data2.main_status)}
            </span>
          </div>

          <div
            className="d-flex flex-wrap"
            style={{
              marginRight: "40px",
              marginTop: "10px",
              direction: "column",
            }}
          >
            <span style={{ color: "#707070" }}>تغییر وضعیت </span>
            <span style={{ marginRight: "5px", marginLeft: "5px" }}>:</span>
            <span className="slectStatuse" style={{}}>
              <Select
                className="input-modal"
                id="statusPreviewSelect"
                options={statusPreviewSelect.filter((value) => {
                  return parseInt(value.value) > parseInt(data2.main_status);
                })}
                placeholder="انتخاب..."
                value={inputValue.statusPreviewSelect}
                onChange={(e) => {
                  console.log("e", e);
                  setInptValue((prev) => {
                    return { ...prev, statusPreviewSelect: e };
                  });
                  changeStatuse(data2.id, e.value);
                }}
              ></Select>{" "}
            </span>
            {/* <span style={{ color: "#707070" }}>تغییر وضعیت سوپرادمین</span>
            <span style={{ marginRight: "5px", marginLeft: "5px" }}>:</span>
            <span className="slectStatuse" style={{}}>
              <Select
                className="input-modal"
                id="statusPreviewSelect"
                options={statusPreviewSelect.filter(
                  (value) => value.value > inputValue.statusPreviewSelect
                )}
                placeholder="انتخاب..."
                value={statusPreviewSelect.find(
                  (val) => val.value == inputValue.statusPreviewSelect
                )}
                onChange={(e) => {
                  setInptValue((prev) => {
                    return { ...prev, statusPreviewSelect: e };
                  });
                  changeStatuse(data2.id, e.value);
                }}
              ></Select>{" "}
            </span> */}
          </div>

          <div style={{ marginRight: "30px", marginTop: "10px" }}>
            <span style={{ color: "#707070" }}> تعداد</span>
            <span style={{ marginRight: "5px", marginLeft: "5px" }}>:</span>
            <span style={{ marginRight: "10px", color: "#fa0520" }}>
              {pageType != "groupList" ? (
                <span>{data2.items_count}</span>
              ) : (
                <span>{data2.itemcount}</span>
              )}{" "}
            </span>
          </div>

          <div style={{ marginRight: "30px", marginTop: "10px" }}>
            <span style={{ color: "#707070" }}> مبلغ </span>
            <span style={{ marginRight: "5px", marginLeft: "5px" }}>:</span>
            <span style={{ marginRight: "10px", color: "#fa0520" }}>
              {addCommas(data2.total_amount)}تومان
            </span>
          </div>
          <div style={{ marginRight: "30px", marginTop: "10px" }}>
            <span style={{ color: "#707070" }}> آدرس خریدار</span>
            <span style={{ marginRight: "5px", marginLeft: "5px" }}>:</span>
            <span style={{ marginRight: "10px", color: "#fa0520" }}>
              {data2.rescipient_address}
              {/* {pageType != "groupList" ? (
                <span>{`${
                  data2.user_muid.length > 0
                    ? data2.user_muid[0].address
                    : "---"
                } `}</span>
              ) : (
                <span>{`${
                  data2.user_info.length > 0
                    ? data2.user_info[0].address
                    : "---"
                } `}</span>
              )}{" "} */}
            </span>
          </div>
          {/* {pageType != "superadmin" ? (
            <div style={{ marginRight: "30px", marginTop: "10px" }}>
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="checkbox"
                  defaultValue
                  id="flexCheckDefault"
                />
                <div style={{ marginRight: "5px" }}>
                  <span style={{ color: "#707070" }}>
                    {" "}
                    بازگشت سود حاصل از خرید به کیف پول{" "}
                  </span>
                  <span style={{ marginRight: "5px", marginLeft: "5px" }}>
                    :
                  </span>
                  <span style={{ marginRight: "10px", color: "#fa0520" }}>
                    {addCommas("178000")}تومان
                  </span>
                </div>
              </div>
            </div>
          ) : (
            ""
          )} */}
        </div>
        <div className="d-flex justify-content-flex-start mx-0 mt-5 flex-wrap ">
          {specialProducts}
        </div>
        <div className="d-flex  mt-3 p-4">
          <div
            style={{
              width: "65%",
              textAlign: "left",
              alignSelf: "center",
              display: "flex",
              justifyContent: "left",
            }}
          >
            {/* <span
              style={{
                color: "rgb(250, 5, 32)",
                fontSize: "16px",
              }}
            >
              {statusPreview(data2.orderStatus)}
            </span> */}
            <div className="accordion" id="accordionExample">
              <div>
                <h2 className="accordion-header" id="headingOne"></h2>
              </div>
            </div>
          </div>
        </div>
        <div
          id={`collapseOne-${index}`}
          className="accordion-collapse collapse "
        >
          <div className="accordion-body d-flex flex-wrap ">
            {moreProducts}
            <div></div>
          </div>
          <div className="ms-5">
            ثبت کننده سفارش:
            {pageType != "groupList" ? (
              <span>{`${data2.user_muid.fname} ${data2.user_muid.lname}`}</span>
            ) : (
              <span>{`${data2.user_info.fname} ${data2.user_info.lname}`}</span>
            )}
          </div>
        </div>
        <div
          className="d-flex align-items-center justify-content-between admin-button"
          style={{ height: "auto" }}
        >
          {/* edit/message icon */}
          <div className="d-flex  justify-content-center buttons"></div>
          {/* accordion button */}
          <div
            data-bs-toggle="collapse"
            data-bs-target={`#collapseOne-${index}`}
            aria-expanded="true"
            aria-controls="collapseOne"
          >
            <div className="d-flex align-items-center justify-content-center me-2">
              <div>
                <a
                  href="#"
                  style={{
                    color: "#457B9D",
                    textDecoration: "none",
                    fontSize: "15px",
                  }}
                  className="mx-auto"
                >
                  جزئیات بیشتر
                </a>
              </div>
            </div>
          </div>
          {/* paid modal */}
          {/* <div className="d-flex align-items-center justify-content-end paid-button">
            {data2.total_amount - data2.total_discount - data2.paid_amount >
            0 ? (
              <span
                data-for="gm-tooltip"
                data-tip=" افزودن تکمیل وجه "
                style={
                  {
                    // marginLeft: "15px",
                  }
                }
              >
                <button
                  style={{
                    marginLeft: "10px",
                    backgroundColor: "#10451d",
                    color: "white",
                    border: "none",
                    borderRadius: "15px",
                    padding: "8px 20px ",
                    fontSize: "18px",
                  }}
                  data-bs-toggle="modal"
                  data-bs-target="#ComolatePriceModal"
                  onClick={() => {
                    updateSelectedItem(data2);
                  }}
                >
                  افزودن تکمیل وجه
                </button>
                <span
                  onClick={() => {
                    updateSelectedItem(data2);
                  }}
                  style={{
                    color: "#457B9D",
                    textDecoration: "none",
                    fontSize: "50px",
                  }}
                  data-bs-toggle="modal"
                  data-bs-target="#StatusReportModal"
                ></span>
              </span>
            ) : (
              <span></span>
            )}
          </div> */}
        </div>
      </div>
    );
  }
}
function ProductsItem({ img, title, price, index, isMore, desc }) {
  return (
    <div className=" col-12 col-md-6 col-lg-6 col-child text-center mt-2 d-flex flex-column justify-content-between">
      {isMore && (
        <div
          style={{
            width: "90%",
            margin: "10px auto  0px auto",
          }}
        ></div>
      )}
      <div className="container-responsive2 d-flex justify-content-start  ">
        <span>
          <img
            src={`http://marketgroup.tatdemo.ir/${img}`}
            style={{ height: "150px", width: "150px", marginRight: "10px" }}
          ></img>
        </span>
        <span className="box-title mt-3 " style={{ textAlign: "right" }}>
          <p style={{ color: "#011c40", fontWeight: "bold", height: "30px" }}>
            {title}
          </p>
          <p style={{ color: "#fa0520", height: "30px" }}>
            {price && `${addCommas(price)}تومان`}
          </p>
          <p>{desc} </p>
        </span>
      </div>
      <div
        style={{
          borderBottom: "2px solid #dcdcdc",
          width: "90%",
          margin: "10px auto  0px auto",
        }}
      ></div>
    </div>
  );
}
